import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  nome: Yup.string().required(() => i18n.t('common:validation.fieldRequired')),
  email: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired'))
    .email(() => i18n.t('common:validation.emailInvalid')),
  password: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired'))
    .min(8, ' ')
    .matches(/[a-z]/, ' ')
    .matches(/[A-Z]/, ' ')
    .matches(/[0-9]/, ' '),
  confirmPassword: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired'))
    .oneOf([Yup.ref('password')], ' '),
  isTermsAccepted: Yup.bool()
    .required(() => i18n.t('auth:validation.termsRequired'))
    .oneOf([true], () => i18n.t('auth:validation.termsRequired')),
});

export default schema;

export const schemaPassword = Yup.object().shape({
  password: Yup.string()
    .min(8, () => i18n.t('auth:validation.passwordChars', { count: 8 }))
    .matches(/[a-z]/, () => i18n.t('auth:validation.passwordLower'))
    .matches(/[A-Z]/, () => i18n.t('auth:validation.passwordUpper'))
    .matches(/[0-9]/, () => i18n.t('auth:validation.passwordNumber')),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('$password'), undefined], () => i18n.t('auth:validation.passwordMatch')),
});
